import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useAuthStudent } from "../../../../context/StudentLoginContext/StudentAuthContext";
import toast from "react-hot-toast";

export const ChangePasswordStudent = ({ showModal, handleQuestClose }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [password, setPassword] = useState("");
  const [confirm_password, setConfirmPassword] = useState("");
  const [passwordmatch, setpasswordmatch] = useState(true);
  const [passwordValid, setPasswordValid] = useState(true);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false); // Toggle for current password visibility
  const [showNewPassword, setShowNewPassword] = useState(false); // Toggle for new password visibility

  const { fetchWithAuthStudent} = useAuthStudent();
  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);

    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (regex.test(newPassword)) {
      setPasswordValid(true);
    }

    // If confirm_password already typed, recheck match
    if (confirm_password) {
      setpasswordmatch(newPassword === confirm_password);
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const confirmPasswordValue = e.target.value;
    setConfirmPassword(confirmPasswordValue);

    setpasswordmatch(password === confirmPasswordValue);

  };

  const handleSubmit = async () => {
    let valid = true;

    setPasswordValid(true);
    setpasswordmatch(true);
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (!passwordRegex.test(password)) {
      setPasswordValid(false);
      valid = false;
    }

    // Confirm password
    if (password !== confirm_password) {
      setpasswordmatch(false);
      valid = false;
    }
    if (valid) {
      try {
        const formData = new FormData();
        formData.append("password", password);
        formData.append("confirm_password", confirm_password);

        const response = await fetchWithAuthStudent(`${apiUrl}/student/update-credentials `, {
          method: "POST",
          body: formData,
        });

        if (response.ok) {
          toast.success("Password updated successfully");
          setTimeout(() => {
            handleQuestClose(); // Close the modal after 5 seconds
          }, 2000);
        } else {
          const error = await response.json();
          toast.error(error.message || "Failed to update password.");
        }
      } catch (error) {
        toast.error("An error occurred. Please try again.");
      }
    }
  };

  return (
    <>
      <Modal show={showModal} onHide={handleQuestClose} centered>
        <div className="modalHeader">
          <Modal.Header closeButton></Modal.Header>
        </div>
        <Modal.Body>
          <div>
            {/* <p className="DelModalTitl">Edit {kid.name}</p> */}
            <form>
              <div className="mb-3">
                <label htmlFor="password" className="form-label">
                  Password
                </label>
                <div className="position-relative">
                  <input
                    type={showCurrentPassword ? "text" : "password"}
                    className={`form-control ${
                      !passwordValid ? "is-invalid no-validation-icon" : ""
                    }`}
                    id="password"
                    onChange={handlePasswordChange}
                    value={password}
                    required
                  />
                  <span
                    className="position-absolute top-50 translate-middle-y"
                    style={{ right: "15px", cursor: "pointer" }}
                    onClick={() =>
                      setShowCurrentPassword((prevState) => !prevState)
                    }
                  >
                    <i
                      className={`fa ${
                        showCurrentPassword ? "fa-eye" : "fa-eye-slash"
                      }`}
                    ></i>
                  </span>
                </div>
                {!passwordValid && (
                  <div className="invalid-feedback d-block">
                    Password must be at least 8 characters long and contain at
                    least one uppercase letter, one lowercase letter, one
                    number, and one special character.
                  </div>
                )}
              </div>
              <div className="mb-3">
                <label htmlFor="confirm_password" className="form-label">
                  Confirm Password
                </label>
                <div className="position-relative">
                <input
                  type={showNewPassword ? "text" : "password"}
                  className={`form-control ${
                    !passwordmatch ? "is-invalid no-validation-icon" : ""
                  }`}
                  id="confirm_password"
                  onChange={handleConfirmPasswordChange}
                  value={confirm_password}
                  required
                />
                <span
                  className="position-absolute top-50 translate-middle-y"
                  style={{ right: "15px", cursor: "pointer" }}
                  onClick={() => setShowNewPassword((prevState) => !prevState)}
                >
                  <i
                    className={`fa ${
                      showNewPassword ? "fa-eye" : "fa-eye-slash"
                    }`}
                  ></i>
                </span>
                </div>
                {!passwordmatch ? (
                  <div className="invalid-feedback d-block">
                    Passwords do not match
                  </div>
                ) : null}
              </div>
            </form>
            <Button
              className="btn btn-primary mt-4 w-100"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      {" "}
    </>
  );
};
